import { WETLAND_RATINGS } from '../types.js';

/**
 * Validates a plant record for required fields and valid wetland ratings.
 * @param {Object} record - The plant record to validate
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validatePlantRecord(record) {
  const errors = [];

  // Check gridRow is a number >= 0
  if (typeof record.gridRow !== 'number' || record.gridRow < 0 || Number.isNaN(record.gridRow)) {
    errors.push('gridRow must be a number >= 0');
  }

  // Check gridCol is a number >= 0
  if (typeof record.gridCol !== 'number' || record.gridCol < 0 || Number.isNaN(record.gridCol)) {
    errors.push('gridCol must be a number >= 0');
  }

  // Check commonName is a non-empty string
  if (typeof record.commonName !== 'string' || record.commonName.trim() === '') {
    errors.push('commonName is required');
  }

  // Check scientificName is a non-empty string
  if (typeof record.scientificName !== 'string' || record.scientificName.trim() === '') {
    errors.push('scientificName is required');
  }

  // Check agcpRating is null, undefined, empty string, or a valid wetland rating
  if (
    record.agcpRating !== null &&
    record.agcpRating !== undefined &&
    record.agcpRating !== '' &&
    !WETLAND_RATINGS.includes(record.agcpRating)
  ) {
    errors.push('agcpRating must be one of: ' + WETLAND_RATINGS.join(', '));
  }

  // Check empRating is null, undefined, empty string, or a valid wetland rating
  if (
    record.empRating !== null &&
    record.empRating !== undefined &&
    record.empRating !== '' &&
    !WETLAND_RATINGS.includes(record.empRating)
  ) {
    errors.push('empRating must be one of: ' + WETLAND_RATINGS.join(', '));
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
